import "../../css/auth.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Spinner from "../../components/skeletons/spinnerButton";
import PrimaryButton from "../../components/buttons/Button";
import GGButton from "../../components/buttons/ggButton";
import FBButton from "../../components/buttons/fbButton";
import { useRegisterMutation } from "../../features/api/authQuery";

function Register() {
  const navigate = useNavigate();

  const [register, { isLoading: isLoadingNormal }] = useRegisterMutation();
  const [isLoadingSpecial, setLoadingSpecial] = useState(false);
  const [serverError, setServerError] = useState("");

  const [formData, setFormData] = useState({
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // Hàm kiểm tra tính hợp lệ của form
  const validateForm = () => {
    const newErrors = {};

    // Kiểm tra số điện thoại
    if (!formData.phone.trim()) {
      newErrors.phone = "Vui lòng nhập số điện thoại";
    } else if (!/^\d{9,11}$/.test(formData.phone)) {
      newErrors.phone = "Số điện thoại không hợp lệ";
    }

    // Kiểm tra mật khẩu
    if (!formData.password) {
      newErrors.password = "Vui lòng nhập mật khẩu";
    } else if (formData.password.length < 8) {
      newErrors.password = "Mật khẩu phải có ít nhất 8 ký tự";
    }

    // Kiểm tra xác nhận mật khẩu
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Vui lòng xác nhận mật khẩu";
    } else if (formData.confirmPassword !== formData.password) {
      newErrors.confirmPassword = "Mật khẩu xác nhận không khớp";
    }

    setErrors(newErrors);

    // Trả về true nếu không có lỗi
    return Object.keys(newErrors).length === 0;
  };

  // Hàm xử lý submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    try {
      await register({
        phone: formData.phone,
        password: formData.password,
      }).unwrap();
      navigate("/auth/login");
    } catch (err) {
      setServerError(err.message);
    }
  };

  return (
    <div className="auth_container">
      {/* Phần tiêu đề */}
      <div className="self-start mb-4" style={{ fontSize: "20px" }}>
        Đăng ký
      </div>
      {/* Phần form đăng ký */}
      <form onSubmit={handleSubmit} className="auth_form">
        <div className="relative w-full">
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Số điện thoại"
            className="border border-gray-300 px-4 py-2 mb-4 w-full rounded"
            required
          />
          {/* Thông báo lỗi nếu có */}
          {errors.phone && (
            <p
              className="absolute text-red-500 text-xs mt-1 left-0"
              style={{ top: "calc(39px)", left: "0" }}
            >
              {errors.phone}
            </p>
          )}
        </div>
        {/* Phần nhập mật khẩu */}
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          placeholder="Mật khẩu"
          className="border border-gray-300 px-4 py-2 mb-4 w-full rounded check_password"
          required
        />
        {/* Phần nhập lại mật khẩu */}
        <div className="relative w-full">
          <input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            placeholder="Nhập lại mật khẩu"
            className="border border-gray-300 px-4 py-2 mb-5 w-full rounded check_password"
            required
          />
          {/* Thông báo lỗi nếu có */}
          {(errors.confirmPassword || errors.password || serverError) && (
            <p className="absolute text-red-500 text-xs mt-1 left-0 top-[39px]">
              {errors.confirmPassword || errors.password || serverError}
            </p>
          )}
        </div>
        {/* Nút đăng ký */}
        <PrimaryButton
          height="40px"
          width="100%"
          text={isLoadingNormal ? "" : "Đăng ký"}
          type="submit"
          disabled={isLoadingSpecial}
        >
          <div
            className={`absolute top-0 left-0 w-full h-full flex items-center justify-center
            ${isLoadingNormal ? "" : `${isLoadingSpecial ? "bg-white/50" : "hidden"}`} `}
          >
            <Spinner
              size={"30px"}
              stroke={"5px"}
              _hidden={isLoadingSpecial ? "hidden" : ""}
              color={"white"}
            />
          </div>
        </PrimaryButton>
      </form>
      {/* Phần đường kẻ */}
      <div
        className="flex items-center justify-center w-full"
        style={{ margin: "32px 0" }}
      >
        <div className="line"></div>
        <div style={{ font: "12px", color: "#DBDBDB", padding: "0 16px" }}>
          Hoặc
        </div>
        <div className="line"></div>
      </div>
      {/* Phần đăng ký bằng tài khoản khác */}
      <div className="flex items-center justify-between w-full gap-4">
        <FBButton
          setLoadingSpecial={setLoadingSpecial}
          disabled={isLoadingNormal}
        >
          <div
            className={`absolute top-0 left-0 w-full h-full flex items-center justify-center
            ${isLoadingSpecial || isLoadingNormal ? "bg-white/50" : "hidden"} `}
          >
            <Spinner
              size={"30px"}
              stroke={"6px"}
              _hidden={isLoadingNormal ? "hidden" : ""}
              color={"#ee4d2d"}
            />
          </div>
        </FBButton>
        <GGButton
          disabled={isLoadingNormal}
          setLoadingSpecial={setLoadingSpecial}
        >
          <div
            className={`absolute top-0 left-0 w-full h-full flex items-center justify-center
            ${isLoadingSpecial || isLoadingNormal ? "bg-white/50" : "hidden"} `}
          >
            <Spinner
              size={"30px"}
              stroke={"6px"}
              _hidden={isLoadingNormal ? "hidden" : ""}
              color={"#ee4d2d"}
            />
          </div>
        </GGButton>
      </div>
      {/* Nếu đã có tài khoản */}
      <div className="text-sm text-[#BDBDBD]" style={{ marginTop: "16px" }}>
        Bạn đã có tài khoản?
        <Link to="/auth/login" className="text-[#FA5130] font-semibold">
          {" "}
          Đăng nhập
        </Link>
      </div>
    </div>
  );
}

export default Register;
